<template>
    <div class="f-form-item">
        <!-- 发帖的 list 包含哪些项目，用 formConfig 去判断 -->
        <span class="f-form-label">
            <span v-if="formConfig.validations && formConfig.validations.required"
                class="f-form-label-required">*</span>
            <span>{{formConfig.label}}</span>
            <!-- 是否显示保密 lock icon，绑一个 tip 在上面-->
            <span v-if="formConfig.encryptType"
                class="fa fa-lock"
                :tip="secretTip">
            </span>
        </span>

        <div v-if="formConfig.type==='buttonbox'" class="f-form-buttonbox">
            <span v-for="item in formConfig.options"
                :key="item.label"
                :class="{'f-form-buttonbox-item': true, 'f-form-buttonbox-item-active': formConfig.defaultValue === item.value}"
                @click="chooseOne(item.value)">
                {{item.label}}
            </span>
        </div>

        <div v-if="formConfig.type==='input'"
            class='f-form-input'>
            <input class="f-form-input-text"
                type="text"
                v-model="formConfig.defaultValue"
                @input="countContent"
                @blur="blurChange"
                @focus="focusChange"
                name="input"
                :maxlength="inputMaxLen"
                :placeholder="formConfig.placeholder"
                autocomplete="off"
                v-validate="{'required': formConfig.validations.required > 0,
                    'max': validateMaxLen}"
                v-validate.disable="!formConfig.validations || formConfig.validations.minLength < 1">
            <div class="f-form-input-cont">
                <span>{{count}}</span>
                <span>/{{formConfig.validations.maxLength}}</span>
            </div>
            <div v-if="errors.has('input')" class="f-form-errors-input">
                {{errors.first('input')}}
            </div>
            <!-- 发帖sug -->
            <div class="f-form-input-sug"
                v-if="titleSugList.length
                    && titleIsFocus && formConfig.isTitle
                    && formConfig.defaultValue.length > 1">
                <div class="f-form-input-sug-title">
                    <span>相关链接</span>
                    <!-- <span>没有找到相关内容</span> -->
                </div>
            </div>
        </div>

        <div v-if="formConfig.type==='radio'" class="f-form-radio">
            <veui-radio-group
                v-model="formConfig.defaultValue"
                :items="formConfig.options"
            />
        </div>

        <div v-if="formConfig.type==='checkbox'" class="f-form-checkbox">
            <label v-for="item in formConfig.options"
                :key="item.value"
                class="f-form-checkbox-item">
                <input type="checkbox"
                    name="checkbox"
                    class="f-form-checkbox-item-icon"
                    v-validate="{'required': formConfig.validations.required}"
                    v-validate.disable="!formConfig.validations"
                    v-model="formConfig.defaultValue"
                    :value="item.value">{{item.label}}
            </label>
            <span v-if="errors.has('checkbox')" class="f-form-errors-checkbox">{{errors.first('checkbox')}}</span>
        </div>

        <div v-if="formConfig.type==='textarea'" class="f-form-input f-form-textarea">
            <textarea class="f-form-textarea-text"
                name="textarea"
                autocomplete="off"
                v-model="formConfig.defaultValue"
                :placeholder="formConfig.placeholder"
                :maxlength="formConfig.validations.maxLength"
                v-validate="{'required': formConfig.validations.required > 0,
                    'max': formConfig.validations.maxLength}"
                v-validate.disable="!formConfig.validations">
            </textarea>
            <div class="f-form-textarea-cont">
                <span>{{count}}</span>
                <span>/{{formConfig.validations.maxLength}}</span>
            </div>
            <div v-if="errors.has('textarea')" class="f-form-errors-textarea">
                {{errors.first('textarea')}}
            </div>
        </div>

        <div v-if="formConfig.uploaderType" class="f-form-uploader">
            <veui-uploader
                :type="formConfig.uploaderType"
                v-model="formConfig.defaultValue"
                :action="action"
                request-mode="custom"
                :upload="upload"
                :max-size="formConfig.uploaderValidations.maxSize"
                :max-count="formConfig.validations.maxCount"
                :accept="formConfig.uploaderValidations.fileFormat"
            >
                <template #desc>
                    <span>{{formConfig.uploaderValidations.tips}}</span>
                </template>
            </veui-uploader>
        </div>


    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/edit-topic/render-component.less';
</style>

<script>
import {RadioGroup, Uploader} from 'veui';
import uploadImg from '@/utils/uploadImg';
import uploadFile from '@/utils/uploadFile';
import {mapState} from 'vuex';

const padZeros = num =>
    (num + '').padStart(2, '0');

const formatDateTime = date =>
    date.getFullYear()
        + '-'
        + padZeros(date.getMonth() + 1)
        + '-'
        + padZeros(date.getDate())
        + ' '
        + padZeros(date.getHours())
        + ':'
        + padZeros(date.getMinutes())
        + ':'
        + padZeros(date.getSeconds());

export default {
    props: {
        formName: String,
        formConfig: Object,
        editorPlaceHolder: {
            'type': String,
            'default': ''
        }
    },
    components: {
        'veui-radio-group': RadioGroup,
        'veui-uploader': Uploader
    },
    data() {
        return {
            defaultTime: this.formConfig.defaultValue ? this.formConfig.defaultValue : formatDateTime(new Date()),
            canEditTime: false,
            titleIsFocus: false,
            origin: window.location.origin,
            action: '',
            // 自定义上传方法
            upload: (file, {onload, onprogress, onerror}) => {
                if(this.formConfig.uploaderType === 'image') {
                    uploadImg(file)
                        .then(data => {
                            let fileSrc = data.imageUrl;
                            onload(file, {success: true, src: `https://${fileSrc}`});
                        })
                        .catch(errmsg => {
                            onerror(file, {success: false, message: '上传出错，请重试'});
                        });
                }

                if(this.formConfig.uploaderType === 'file') {
                    uploadFile(file)
                        .then(data => {
                            let fileSrc = data.fileUrl;
                            onload(file, {success: true, src: `https://${fileSrc}`});
                        })
                        .catch(errmsg => {
                            onerror(file, {success: false, message: '上传出错，请重试'});
                        });
                }
            }
        };
    },
    computed: {
        ...mapState({
            secretTip: state => state.editTopic.secretTip
        }),
        inputMaxLen: {
            get() {
                return this.formConfig.validations.maxLength;
            }
        },
        validateMaxLen: {
            get() {
                if (this.formConfig.label === '帖子标题') {
                    return Math.max(
                        this.$store.state.editTopic.issueTitleLen,
                        this.$store.state.editTopic.notIssueTitleLen
                    );
                }
                return this.formConfig.validations.maxLength;
            }
        },
        count: {
            get() {
                return this.formConfig.defaultValue.length;
            },
            set(newVal) {
                return newVal;
            }
        },
        radioValue: {
            get() {
                for (let opt of this.formConfig.options) {
                    if (opt.value === this.formConfig.defaultValue) {
                        return this.formConfig.defaultValue;
                    }
                }
                return 'INPUT';
            },
            set(newVal) {
                return newVal;
            }
        },
        titleSugList: {
            get() {
                return this.$store.state.editTopic.titleSugList;
            },
            set(newVal) {
                this.$store.state.editTopic.titleSugList = newVal;
            }
        }
    },
    mounted() {
        if (this.formName) {
            this.$store.commit('addComponent', this.formName);
        }

        if (this.formConfig.type === 'datetime') {
            this.setSelectedTime();
        }
    },
    updated() {
        if (Object.keys(this.editorPlaceHolder).length) {
            let placeholder = this.editorPlaceHolder[this.formConfig.defaultValue];
            this.$emit('changeEditPlaceholder', placeholder);
        }
    },
    beforeDestroy() {
        this.$store.commit('removeComponent', this.formName);
    },
    methods: {
        countContent() {
            this.count = this.formConfig.defaultValue.length;
        },
        focusChange() {
            this.titleIsFocus = true;
        },
        blurChange() {
            this.titleIsFocus = false;
        },
        chooseOne(id) {
            this.formConfig.defaultValue = id;
        },
        changeDefaultValue(value) {
            if (value === 'INPUT') {
                this.formConfig.defaultValue = '';
            }
            else {
                this.formConfig.defaultValue = value;
            }
        },
        setSelectedTime() {
            this.formConfig.defaultValue = this.defaultTime;
        },
        navigatToTopic(item) {
            window.open(`/community/topic/show/${item.id}`);
        },
        mouseDown(e) {
            let event = e || window.event;
            event.preventDefault();
        },
        navigateToSmart(item) {
            window.open(`${this.origin}${item.path}`);
        }
    }
};
</script>
